module.exports = __webpack_public_path__ + "img/products_client.dd4ec965.png";